import { createContext, useContext } from "react";
import { IT } from "./it";

export const LanguageContext = createContext({
  lang: "en",
  setLang: () => {},
  t: (s) => s,
});

export const useLang = () => useContext(LanguageContext);

// Translate an English-source string. Falls back to the original string when
// no Italian entry exists, so partial coverage never breaks the UI.
export const translate = (lang, s) => {
  if (lang === "en" || s == null) return s;
  return Object.prototype.hasOwnProperty.call(IT, s) ? IT[s] : s;
};
